export default __webpack_public_path__ + "static/media/fw-amelia-er-Rose Gold.bea49641.mp4";